<template>
  <div class="item">
    <!-- header -->
    <div class="header flex center gaps">
      <div class="box">
        <small>
          {{ index + 1 }}.テキストリスト型
        </small>
      </div>
      <div class="box grow" />
      <div class="box">
        <el-button
          v-if="!isSetConfigSource"
          type="text"
          size="small"
          class="deleteButton"
          @click="$emit('deleteItem', index)"
        >
          削除
        </el-button>
      </div>
    </div>

    <!-- inputs -->
    <div class="inputs flex center gaps">
      <div class="box">
        <small>
          項目名:
        </small>
      </div>
      <div class="box">
        <el-input
          v-model="item.name"
          size="small"
        />
      </div>
      <div class="box grow" />
    </div>

    <!-- list -->
    <div class="list">
      <div class="label">
        リストアイテム
      </div>
      <div class="label">
        デフォルト選択
      </div>
      <div class="label">
        操作
      </div>

      <template v-for="(listItem, index) in item.listItems">
        <div
          class="value"
          :key="`listItem-input${index}`"
        >
          <el-input
            v-model="item.listItems[index]"
            size="small"
            @input="changeListItem"
          />
        </div>
        <div
          class="value flex center"
          :key="`listItem-default${index}`"
          @click="selectDefaultValue(listItem)"
        >
          <div class="value-cover" />
          <div class="box">
            <i
              v-if="item.listItems[index] === item.defaultValue"
              class="el-icon-success"
            />
            <i
              v-if="item.listItems[index] !== item.defaultValue"
              class="el-icon-circle-check"
            />
          </div>
        </div>
        <div
          class="value delete flex center"
          :key="`listItem-action${index}`"
          @click="deleteListItem(index)"
        >
          <div class="value-cover" />
          <div class="box">
            {{ !isSetConfigSource ? "削除" : "" }}
          </div>
        </div>
      </template>

      <div class="action">
        アイテム数: {{ item.listItems.length }}
      </div>
      <div class="action" />
      <div
        class="action add"
        @click="item.listItems.push('')"
      >
        {{ !isSetConfigSource ? "追加" : "" }}
      </div>
    </div>

    <!-- checkboxes -->
    <div class="checkboxes">
      <el-checkbox v-model="item.enabled">
        有効
      </el-checkbox>
      <el-checkbox v-model="item.required">
        必須項目
      </el-checkbox>
    </div>
  </div>
</template>

<script>
export default {
  name: "AdminOrderCustomFieldItemsTextList",
  props: {
    item: Object,
    index: Number,
    isSetConfigSource: Boolean,
  },
  data () {
    return {
    };
  },
  computed: {
  },
  watch: {
  },
  created () {
  },
  methods: {
    selectDefaultValue (listItem) {
      if (listItem) {
        this.item.defaultValue = this.item.defaultValue !== listItem ? listItem : null;
      } else {
        this.$notify.warning({
          title: "空の入力はデフォルト選択に指定できません",
          duration: 5000,
        });
      }
    },

    deleteListItem (index) {
      if (!window.confirm("リストアイテムから削除してもよろしいですか？")) {
        return;
      }

      this.item.listItems.splice(index, 1);
      this.changeListItem();
    },

    changeListItem () {
      const {
        defaultValue,
        listItems,
      } = this.item;

      const d = listItems.find(listItem => listItem === defaultValue);

      if (!d) {
        this.item.defaultValue = null;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/variables.scss";
@import "~@/assets/styles/custom-fields.scss";
</style>
